/** @format */

export const SEARCH_DEBOUNCE_TIME = 300;
